import type { ColumnDef } from '@tanstack/react-table';
import { ActionIcon, Badge, Group, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconFileTypePdf, IconTrash } from '@tabler/icons-react';
import type { ICotizacionPostventaResumen } from '../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';
import { formatoMoneda } from '../interfaces';

interface ColumnasTablaCotizacionesPostventaParams {
    alEditar: (cotizacion: ICotizacionPostventaResumen) => void;
    alGenerarPdf: (cotizacion: ICotizacionPostventaResumen) => void;
    alEliminar: (cotizacion: ICotizacionPostventaResumen) => void;
}

const estiloTooltip = { fontSize: '10px', padding: '3px 5px' };

export const columnasTablaCotizacionesPostventa = ({ alEditar, alGenerarPdf, alEliminar }: ColumnasTablaCotizacionesPostventaParams): ColumnDef<ICotizacionPostventaResumen>[] => [
    {
        id: 'actions',
        header: 'Acciones',
        cell: ({ row }) => (
            <Group gap={4} justify="center" wrap="nowrap">
                <Tooltip label="Editar" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alEditar(row.original)}>
                        <IconEdit size={18} />
                    </ActionIcon>
                </Tooltip>
                <Tooltip label="Generar PDF" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alGenerarPdf(row.original)}>
                        <IconFileTypePdf size={18} />
                    </ActionIcon>
                </Tooltip>
                <Tooltip label="Eliminar" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alEliminar(row.original)}>
                        <IconTrash size={18} />
                    </ActionIcon>
                </Tooltip>
            </Group>
        )
    },
    { accessorKey: 'Proyecto', header: 'Proyecto', cell: ({ row }) => <Text size="xs" fw={600}>{row.original.Proyecto}</Text> },
    { accessorKey: 'Cliente', header: 'Cliente', cell: ({ row }) => <Text size="xs">{row.original.Cliente}</Text> },
    { accessorKey: 'Descripcion', header: 'Trabajo', cell: ({ row }) => <Text size="xs" lineClamp={1} maw={260}>{row.original.Descripcion}</Text> },
    { accessorKey: 'NumeroUnidades', header: 'Unidades', cell: ({ row }) => <Text size="xs">{row.original.NumeroUnidades}</Text> },
    { accessorKey: 'PrecioVentaTotal', header: 'Precio total', cell: ({ row }) => <Text size="xs">{formatoMoneda(row.original.PrecioVentaTotal)}</Text> },
    {
        id: 'estado',
        header: 'Estado',
        cell: ({ row }) => <Badge size="sm" variant="light" style={{ textTransform: 'none' }}>{row.original.Estado?.Nombre ?? 'Borrador'}</Badge>
    },
    { accessorKey: 'UsuarioCreadorNombre', header: 'Elaboró', cell: ({ row }) => <Text size="xs">{row.original.UsuarioCreadorNombre ?? '-'}</Text> },
    {
        accessorKey: 'FechaCreacion',
        header: 'Fecha',
        cell: ({ row }) => <Text size="xs">{new Date(row.original.FechaCreacion).toLocaleDateString('es-CO')}</Text>
    }
];
